/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountKycStatusInput
 */
export interface AccountKycStatusInput {
    /**
     * UTC Unix timestamp
     * @type {string}
     * @memberof AccountKycStatusInput
     */
    updateDate: string;
}

/**
 * Check if a given object implements the AccountKycStatusInput interface.
 */
export function instanceOfAccountKycStatusInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updateDate" in value;

    return isInstance;
}

export function AccountKycStatusInputFromJSON(json: any): AccountKycStatusInput {
    return AccountKycStatusInputFromJSONTyped(json, false);
}

export function AccountKycStatusInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountKycStatusInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateDate': json['updateDate'],
    };
}

export function AccountKycStatusInputToJSON(value?: AccountKycStatusInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateDate': value.updateDate,
    };
}

